import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-pwd-id-template',
  templateUrl: './pwd-id-template.component.html',
  styleUrls: ['./pwd-id-template.component.scss']
})
export class PwdIdTemplateComponent implements OnInit {
  @Input() card: any;
  @Input() index: number;

  constructor() { }

  ngOnInit(): void {
  }
}
